import { render, staticRenderFns } from "./Ordenes.vue?vue&type=template&id=5eb7650f&scoped=true"
import script from "./Ordenes.vue?vue&type=script&lang=js"
export * from "./Ordenes.vue?vue&type=script&lang=js"
import style0 from "./Ordenes.vue?vue&type=style&index=0&id=5eb7650f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb7650f",
  null
  
)

export default component.exports